import type { DocMigration } from "../docMigration";

const OLD_SYMBOL = "OUTLET";
const NEW_SYMBOL = "HIGH_VOLTAGE_OUTLET";
const IDS_TO_MIGRATE = new Set(["OUTLET_240V", "OUTLET_220V"]);

const migration: DocMigration = {
  id: "20260710_outlet_240v_220v_high_voltage_symbol",
  description: "Give the 240V and 220V outlet catalog items their own high-voltage (three-prong) symbol",
  apply(json: any) {
    for (const setting of Object.values(json.settings ?? {}) as any[]) {
      if (setting.type !== "ELECTRICAL_ITEM_CATALOG_SETTINGS") {
        continue;
      }

      for (const loadType of Object.values(setting.loadTypes ?? {}) as any[]) {
        if (loadType.symbol === OLD_SYMBOL && IDS_TO_MIGRATE.has(loadType.id)) {
          loadType.symbol = NEW_SYMBOL;
        }
      }
    }

    return json;
  },
};

export default migration;
